<template>
  <Admin style="background: #f2f2f2;">
    <v-main>
      <v-container fluid>
        <v-card class="rounded-xl tw-min-h-80">
          <v-card-text v-if="!selectedCompany.isDemo">
            <v-breadcrumbs :items="items">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
              <template v-slot:item="{ item }">
                <v-breadcrumbs-item
                  :to="item.to"
                  :disabled="item.disabled"
                  :exact="true">
                  {{ item.text }}
                </v-breadcrumbs-item>
              </template>
            </v-breadcrumbs>

            <div class="tw-grid tw-grid-cols-3 tw-mx-5 tw-mb-2 tw-mt-2">
              <div class="tw-col-span-2 tw-font-bold tw-text-xl tw-text-black tw-tracking-wide">โปรแกรมบัญชี</div>
              <!-- <div class="tw-text-right">
                <v-btn text @click="addSettingErp" class="tw-p-0">
                  <v-icon color="#6ec39b" class="tw-text-3xl">mdi-plus-circle-outline</v-icon>
                  <span class="tw-font-bold tw-text-light-green tw-text-base tw-pl-1">เพิ่มโปรแกรมบัญชี</span>
                </v-btn>
              </div> -->
            </div>
            <div v-for="erp in erpList" :key="erp.id" class="tw-mx-5 tw-mt-4">
              <v-row class="flex-detail tw-mb-2">
                <v-col class="pb-0">
                  <v-row>
                    <v-col cols="12" md="4" class="padding-name">
                      <div>โปรแกรมบัญชีที่ใช้อยู่</div>
                      <div :class="erp.type === 1 ? 'bold-orange' : 'bold-red'">
                        {{ getNameProgram(erp.type) }}
                      </div>
                    </v-col>
                    <v-col cols="12" md="3">
                      <div>สถานะ</div>
                      <div class="bold-green">
                        Online
                      </div>
                    </v-col>
                    <v-col cols="12" md="3">
                      <div>วันที่และเวลาที่อัปเดตล่าสุด</div>
                      <div class="date-item">
                        {{ erp.timeCreated }}
                      </div>
                    </v-col>
                    <v-col cols="12" md="2" class="flex-item action-button text-right">
                      <!-- <v-btn icon color="black" @click="editSettingErp(erp.id)">
                        <img src="/images/icons/edit_user.svg" alt="edit"
                             style="vertical-align: middle; max-width: 26px;"/>
                      </v-btn> -->
                      <v-btn icon color="black" class="ml-2" @click="deleteSettingErp(erp.id)">
                        <img src="/images/icons/delete_user.svg" alt="delete"
                             style="vertical-align: middle; max-width: 26px;"/>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <!-- <v-row class="footer-box">
                    <v-col>
                      <div class="api-key">API Key <span class="ml-4">{{ erp.apiKey }}</span></div>
                    </v-col>
                  </v-row> -->
                </v-col>
              </v-row>
            </div>
            <v-progress-linear indeterminate color="green" class="tw-mx-5 tw-mt-4" style="width: 97%" v-if="loading"/>
          </v-card-text>
          <div v-else class="align-center justify-center" style="height: 200px; display: flex;">
            No Permission
          </div>
        </v-card>
        <dialog-setting-erp :erpId="erpId"></dialog-setting-erp>
      </v-container>
    </v-main>
  </Admin>
</template>

<script>
import Admin from '../../components/admin/admin-main-template'
import {mapState} from "vuex";
import DialogSettingErp from "@/components/admin/settings/dialog-setting-erp";

export default {
  name: 'Settings',
  components: {
    Admin,
    DialogSettingErp
  },
  computed: mapState({
    erpList: state => state.databasesByCompany.erpList,
    loading: state => state.databasesByCompany.loading,
    selectedCompany: state => state.companies.selectedCompany,
    isModal: state => state.databasesByCompany.isModal,
  }),
  data: function () {
    return {
      items: [
        {
          text: 'ตั้งค่า',
          disabled: false,
          to: {name: 'Company.Settings'},
        },
        {
          text: 'โปรแกรมบัญชี',
          disabled: true,
        },
      ],

      erpId: ''
    };
  },
  created() {
    this.query();
  },
  beforeDestroy() {
    this.$store.dispatch('databasesByCompany/getDataListUnsubscribe')
  },
  methods: {
    query: function () {
      let companyId = this.$route.params.companyId
      if (companyId) {
        this.$store.dispatch('databasesByCompany/getData', {id: companyId})
      }
    },
    deleteSettingErp: function (erpId) {
      let companyId = this.$route.params.companyId
      if (companyId) {
        this.$store.dispatch('databasesByCompany/deleteData', {erpId, companyId})
      }
    },
    editSettingErp: function (erpId) {
      this.erpId = erpId
      this.$store.dispatch('databasesByCompany/setModal')
    },
    addSettingErp: function () {
      this.erpId = ""
      this.$store.dispatch('databasesByCompany/setModal')
    },
    getNameProgram(type) {
      switch (type) {
        case 1:
          return "SAP Business One"
        case 2:
          return "Express"
        default:
          return ""
      }
    },
  },
}
</script>

<style lang="scss">
.row-wrapper {
  padding-left: 20px;
}

.border-radius {
  border: 1px solid #707070;
  border-radius: 20px;
}

%flex-container {
  display: flex;
  flex-flow: row wrap;
}

.flex-detail {
  @extend %flex-container;

  //height: 154px;
  border-radius: 20px;
  border: solid 1px #707070;
  background-color: #ffffff;
  //margin: 15px;
  font-size: 16px;

  %equal-text {
    margin-top: 20px;
    font-size: 24px;
    font-weight: bold;
    font-style: normal;
  }

  .bold-green {
    @extend %equal-text;
    color: #6ec39b;
  }

  .bold-orange {
    @extend %equal-text;
    color: #fcb017;
  }

  .bold-red {
    @extend %equal-text;
    color: #c9242b;
  }

  .date-item {
    margin-top: 20px;
    font-size: 16px;
    font-weight: 500;
    color: #191919;
  }

  .padding-name {
    padding-left: 19px;
  }

  @media all and (max-width: 959px) {
    .padding-name {
      padding-left: 12px;
    }
  }
}

.flex-detail > * {
  flex: 1 100%;
}

.action-button {
  align-self: center;
}

.main-box {
  min-height: 110px;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
}

.footer-box {
  padding-left: 12px;
  min-height: 50px;
  background-color: #f2f2f2;

  border-top: solid 1px #707070;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;

  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;

  .api-key {
    font-size: 16px;
    font-weight: bold;
    color: #191919;
  }

  span {
    font-weight: normal;
  }
}

@media all and (min-width: 800px) {
  .main-box {
    order: 1;
  }
  .footer-box {
    order: 2;
  }
}

.flex-input {
  @extend %flex-container;

  .flex-input-item {
    padding-left: 15px;
    padding-right: 15px;

    min-width: 50%;

    .v-text-field fieldset, .v-text-field .v-input__control, .v-text-field .v-input__slot {
      border-radius: 10px;
    }
  }
}

.save-button {
  font-size: 16px;
  font-weight: bold;
  color: #6ec39b
}
</style>
